import { render } from "./FilterLoyaltyUom.vue?vue&type=template&id=d84b3bce"
import script from "./FilterLoyaltyUom.vue?vue&type=script&lang=js"
export * from "./FilterLoyaltyUom.vue?vue&type=script&lang=js"
script.render = render

export default script